export interface StatRow {
  readonly row: HTMLElement;
  readonly fill: HTMLElement;
  readonly value: HTMLElement;
}

export function createStatRow(label: string, modifier: string): StatRow {
  const row = document.createElement('div');
  row.className = `stat-row ${modifier}`;

  const labelEl = document.createElement('span');
  labelEl.className = 'stat-label';
  labelEl.textContent = label;

  const bar = document.createElement('div');
  bar.className = 'stat-bar';

  const fill = document.createElement('div');
  fill.className = 'stat-fill';
  bar.appendChild(fill);

  const value = document.createElement('span');
  value.className = 'stat-value';
  value.textContent = '0';

  row.append(labelEl, bar, value);
  return { row, fill, value };
}

export function applyBar(
  fill: HTMLElement,
  value: HTMLElement,
  current: number,
  max: number
): void {
  const ratio = max > 0 ? Math.max(0, Math.min(1, current / max)) : 0;

  // Avoid touching the DOM when the rendered value would be identical —
  // fractional fuel drain triggers ~60 emits/sec while the rounded display
  // only changes once a second, so writing every emit causes unnecessary
  // style invalidation and text node mutations.
  const widthStr = `${(ratio * 100).toFixed(1)}%`;
  if (fill.dataset['lastWidth'] !== widthStr) {
    fill.style.width = widthStr;
    fill.dataset['lastWidth'] = widthStr;
  }

  const valueStr = `${Math.round(current)}`;
  if (value.textContent !== valueStr) {
    value.textContent = valueStr;
  }

  fill.classList.toggle('is-low', ratio < 0.25);
  fill.classList.toggle('is-critical', ratio < 0.1);
}
